import ComoAgentForm from "../Components/ComoAgents/ComoAgentForm";

const ComoAgentFormPage = () => {
  return (
    <div>
      <ComoAgentForm />
    </div>
  );
};

export default ComoAgentFormPage;
